import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import { checkValidEmail, notify } from '../../utils';
import TextField from '@material-ui/core/TextField';
import { ERROR_MESSAGE, REQUIRED_ERROR } from '../../utils/constants';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Paths } from '../../Routes/routePaths'
import { useParams } from "react-router-dom";
import { AdministratorServices } from '../../Services/AdministratorServices';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppLoader from '../../Components/AppLoader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { useHistory } from 'react-router';
import commonStyles, { pageTitleStyles } from 'theme/commonStyles';

const administratorServices = new AdministratorServices();

const useStyles = makeStyles((theme) => ({
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
        margin: '0 0 24px'
    },
    heading: {
        ...pageTitleStyles
    },
    btn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
    },
    cancelBtn: {
        padding: '8px 16px',
        minHeight: 40,
        height: 40,
        background: '#B7B7B7',
        fontSize: '13px',
        color: 'white',
        borderRadius: '5px',
        marginLeft: '15px',
        "&:hover": {
            background: "#454343"
        }
    },
    placeBtn: {
        display: 'flex',
        justifyContent: 'end',
        padding: '20px 0'
    },
    btnPwd: {
        background: '#3D7DDD',
        color: 'white',
        borderRadius: '8px',
        padding: '6px 12px',
        minHeight: 32,
        height: 32,
        marginLeft: theme.spacing(1),
        "&:hover": {
            background: "#3D7DDD"
        }
    },
    formField: {
        width: '100%',
    },
}));

const initFormState = { firstName: "", lastName: "", userName: "", email: "", location: "", password: "", is_active: true };

const AddAdministrator = () => {

    const classes = useStyles();
    const commonClasses = commonStyles();
    const history = useHistory();

    const { id } = useParams();
    const [loading, setLoading] = React.useState(false);
    const [pageLoading, setPageLoading] = React.useState(Boolean(id));
    const [formState, setFormState] = React.useState({ ...initFormState });
    const [update, setUpdate] = React.useState(false);

    React.useEffect(() => {
        if (id) {
            getAdminisratorDetail();
        }
    // The route id is fixed for this mounted create/edit screen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function getAdminisratorDetail() {
        try {
            let data = await administratorServices.getAdminisratorDetail(id)
            if (data && data.data[0]) {
                let userData = data.data[0]
                setUpdate(true);
                setFormState({ ...userData });
            }
        } finally {
            setPageLoading(false);
        }
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        if (name === 'email') {
            setFormState({ ...formState, email: value, userName: value });
        } else {
            setFormState({ ...formState, [name]: value });
        }
    }

    const handleChange = (event) => {
        setFormState({ ...formState, [event.target.name]: event.target.checked });
    };

    const formValidationCheck = () => {
        if (!formState.firstName || !formState.lastName || !formState.userName || !formState.email) {
            notify("error", REQUIRED_ERROR);
            return null;
        }
        if (!checkValidEmail(formState.email)) {
            notify("error", ERROR_MESSAGE.VALID_EMAIL);
            return null;
        }
        return handleFormSubmit();
    }

    const handleFormSubmit = async () => {
        setLoading(true);
        const payload = {
            ...formState,
            userName: formState.email
        };
        let uuid = (update) ? id : null;
        await administratorServices.addAdministrator(payload, uuid).then(
            data => {
                notify('success', data.message);
                setLoading(false);
                history.push(Paths.Administrators);
            },
            error => {
                setLoading(false);
                notify("error", error.response.data.message ? error.response.data.message : 'Something Went Wrong');
                console.log('error.response.status', error);
            }
        );
    }

    const generatePassword = evt => {
        evt.preventDefault();
        let newPwd = '';
        let pwdChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890*/&%$#@!';
        for (let i = 0; i < 8; i++) {
            newPwd += pwdChars[Math.floor(Math.random() * pwdChars.length)];
        }
        if (newPwd) {
            setFormState({ ...formState, password: newPwd })
        }
    };

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    {pageLoading ? <AppLoader minHeight={320} /> : (
                    <>
                    <div className={classes.pageHeader}>
                        <Typography
                            variant="subtitle2"
                            className={classes.heading}
                            color="textPrimary">
                            {update ? "Update Administrator" : "Create Administrator"}
                        </Typography>
                        {update ? (
                            <FormControlLabel
                                control={<Switch
                                    checked={formState.is_active}
                                    onChange={handleChange}
                                    name="is_active"
                                />}
                                label="Account Status"
                            />
                        ) : null}
                    </div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="First Name *"
                                name="firstName"
                                value={formState.firstName}
                                onChange={handleInputChange}
                                className={classes.formField}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Surname *"
                                name="lastName"
                                value={formState.lastName}
                                onChange={handleInputChange}
                                className={classes.formField}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Username *"
                                name="userName"
                                value={formState.userName}
                                placeholder="Username (same as Email)"
                                disabled={true}
                                className={classes.formField}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Email *"
                                name="email"
                                type="email"
                                value={formState.email}
                                onChange={handleInputChange}
                                disabled={update}
                                className={classes.formField}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Location"
                                name="location"
                                value={formState.location}
                                onChange={handleInputChange}
                                className={classes.formField}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                    {update ? (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 0 }}>
                                    <TextField
                                        variant="outlined"
                                        label="Password"
                                        name="password"
                                        type="text"
                                        value={formState.password}
                                        onChange={handleInputChange}
                                        className={classes.formField}
                                        size="small"
                                        style={{ flex: 1, maxWidth: 280 }}
                                    />
                                    <Button size="small" className={classes.btnPwd} onClick={generatePassword}>Generate Password</Button>
                                </div>
                            </Grid>
                        </Grid>
                    ) : null}
                    <div className={classes.placeBtn}>
                        <Button onClick={() => history.push(Paths.Administrators)} variant="outlined" color="default" className={classes.cancelBtn}>
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.btn}
                            onClick={formValidationCheck}>
                            {loading ? <CircularProgress size={15} color="secondary" /> : update ? "Update" : "Save"}
                        </Button>
                    </div>
                    </>
                    )}
                </div>
            </main>
        </Layout>
    );
}

export default AddAdministrator;
